import { useEffect, useState } from "react";
import { config, fuelTypes, transmission } from "../../utils/config";
import {
  fetchDataAndMapToField,
  waitForCookie,
} from "../../utils/helperFuctions";
import { damageTypeStatus, vehicleStatus } from "./VehiclesPage";
import { getCookie } from "../../utils/cookieHandler";
const admin = process.env.REACT_APP_ADMIN_ROLE;
const currentRole1 = getCookie("_r");
const isAdmin = currentRole1 === admin;
const disabledIfRented = {
  field: "status.defaultValue",
  isEqual: isAdmin === true ? [] : ["Rented"],
};
const useVehiclesLogic = () => {
  const apiRoute = "vehicles";
  const onlyForm = undefined;
  const [tabsData, setTabsData] = useState([]);

  const initFields = [
    {
      name: "type",
      label: "Type",
      type: "dropdown",
      isRequired: true,
      err: "Type is required",
      returnID: true,
      span: 3,
    },
    {
      name: "brand",
      label: "Brand",
      type: "dropdown",
      isRequired: true,
      err: "Brand is required",
      returnID: true,
      span: 3,
    },
    {
      name: "model",
      label: "Model",
      type: "dropdown",
      isRequired: true,
      err: "Model is required",
      filters: {
        brand: "brand.id",
      },
      lazyloadFieldChange: ["brand"],
      lazyloadParam: "name",
      lazyloadUrl: "vehiclemodels",
      returnID: true,
      span: 3,
    },
    {
      name: "class",
      label: "Category",
      type: "dropdown",
      isRequired: true,
      err: "Category is required",
      returnID: true,
      span: 3,
    },
    {
      name: "plate",
      label: "Plate",
      type: "text",
      isRequired: true,
      err: "Plate is required",
      span: 3,
    },
    {
      name: "year",
      label: "Year",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "Year is required",
      span: 3,
    },
    {
      name: "location",
      label: "Location",
      type: "dropdown",
      isRequired: true,
      err: "Location is required",
      returnID: true,
      span: 3,
    },
    {
      name: "odometer",
      disabledIfField: disabledIfRented,
      label: "Odometer",
      type: "number",
      converter: { ratio: "1.609344", decimal: 0, placeholder: "Miles" },
      minValue: 0,
      isRequired: true,
      err: "Odometer is required",
      span: 4,
    },
    {
      name: "color",
      label: "Color",
      type: "dropdown",
      isRequired: true,
      err: "Color is required",
      returnID: true,
      span: 3,
    },
    {
      name: "passengers",
      label: "Passengers",
      type: "number",
      isRequired: false,
      err: "Passengers is required",
      span: 3,
      minValue: 1,
    },
    {
      name: "fuel_type",
      label: "Fuel type",
      type: "dropdown",
      isRequired: false,
      err: "Fuel type is required",
      data: fuelTypes,
      span: 3,
    },
    {
      name: "partner_vehicle",
      type: "toggle",
      label: "Partner vehicle",
      span: 3,
      // padding: true,
    },
    {
      name: "fuel_level",
      disabledIfField: disabledIfRented,
      label: "Fuel level",
      type: "number",
      isRequired: false,
      err: "Fuel level is required",
      span: 3,
      minValue: 0,
      step: 0.5,
      maxValue: 8,
    },
    {
      name: "transmission",
      label: "Transmission",
      type: "dropdown",
      isRequired: true,
      err: "Transmission is required",
      data: transmission,
      span: 3,
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      isRequired: true,
      err: "Status is required",
      data: vehicleStatus,
      span: 3,
    },
    {
      name: "image",
      label: "Main Image",
      type: "file",
      isRequired: false,
      err: "File is required",
      isMulti: false,
      span: 3,
    },
    {
      name: "id",
      label: "Note",
      type: "text",
      isRequired: false,
      span: 6,
      hide: true,
    },
    {
      name: "note",
      label: "Note",
      type: "text",
      isRequired: false,
      span: 6,
    },
    // {
    //   name: "registration_document",
    //   label: "Registration document",
    //   type: "file",
    //   isRequired: false,
    //   err: "File is required",
    //   isMulti: false,
    //   span: 3,
    // },
    {
      name: "registration_documents",
      label: "Registration document",
      type: "file",
      isRequired: false,
      err: "File is required",
      isMulti: true,
      span: 3,
    },
    // {
    //   name: "insurance_document",
    //   label: "Insurance document",
    //   type: "file",
    //   isRequired: false,
    //   err: "File is required",
    //   isMulti: false,
    //   span: 3,
    // },
    {
      name: "insurance_documents",
      label: "Insurance document",
      type: "file",
      isRequired: false,
      err: "File is required",
      isMulti: true,
      span: 3,
    },
    {
      name: "files",
      label: "Vehicle Files",
      type: "file",
      isRequired: false,
      err: "Files are required",
      isMulti: true,
      span: 1,
    },
    {
      name: "damageImage",
      related: "vehicle_damages",
      label: "Damage image",
      type: "clickableImage",
      isRequired: false,
      url: "/vehicleDamages",
      err: "Damage image is required",
      span: 2,
      mdSpan: 6,
    },
    {
      name: "vehicle_damages",
      label: "Vehicle damages",
      type: "card",
      isRequired: false,
      rowActionsShowNew: true,
      apiUrl: "vehicledamages",
      parentParam: "vehicle",
      err: "Damage image is required",
      span: 2,
      exclude: {
        name: "delete",
        value: true,
      },
      rowActions: [
        {
          name: "Edit",
          id: "edit",
          url: "/vehicledamages",
        },

        {
          name: "Mark Fixed",
          id: "update",
          url: "/vehicledamages",
          data: {
            status: "Fixed",
          },
        },
        {
          name: "Delete",
          id: "update",
          url: "/vehicledamages",
          data: {
            delete: true,
          },
        },
      ],
      toShow: {
        title: "number,<s>-,damage_type.name",
        id: "id",
        tempid: "tempid",
        status: "status",
        createdBy: "user_created.first_name, ,user_created.last_name",
        createdOn: "date_created",
        description: "description",
        image: "image.name",
      },
      formOptions: {
        label: "Create new damage",
        fields: [
          {
            name: "status",
            label: "Status",
            type: "dropdown",
            isRequired: true,
            err: "Status is required",
            returnID: false,
            span: 1,
            data: damageTypeStatus,
            defaultValue: "Pending",
            hideNew: true,
          },
          {
            name: "damage_type",
            label: "Damage type",
            type: "dropdown",
            isRequired: true,
            err: "Damage type is required",
            returnID: true,
            returnObject: true,
            span: 1,
            lazyloadUrl: "damagetypes",
          },
          {
            name: "description",
            label: "Description",
            type: "text",
            isRequired: false,
            err: "Description is required",
            span: 1,
          },

          {
            name: "image",
            label: "Damage image",
            type: "file",
            isRequired: false,
            err: "Image is required",
            isMulti: false,
            span: 3,
          },
        ],
      },
    },
    {
      name: "temporaryRta",
      label: "Temporary Rta",
      type: "temporaryRta",
      span: 6,
    },
    {
      name: "contracts_display",
      label: "Contracts display",
      type: "contracts_display",
      span: 6,
    },
    {
      name: "class_display",
      label: "Class",
      type: "multiFieldsDisplay",
      displayFields: [
        "id",
        "brand.name",
        "model.name",
        "color.name",
        "year",
        "plate",
      ],
      span: 3,
    },
    {
      name: "lending-contract",
      label: "Lending Contract",
      type: "contract-generator",
      span: 6,
    },
    {
      name: "vehicle_insurance",
      label: "Insurance details",
      type: "card",
      isRequired: false,
      useIndexAsKey: true,
      span: 2,
      headerAction: {
        name: "Add",
        id: "add",
      },
      toShow: {
        title: "insurance_type.name,,<date>expiry_date",
        id: "id",
        tempid: "tempid",
        // status: "branch.email",
        createdBy: "user_created.first_name, ,user_created.last_name",
        createdOn: "date_created",
        delete: "delete",
      },
      rowActionsShowNew: true,

      exclude: {
        name: "delete",
        value: true,
      },

      rowActions: [
        {
          name: "Edit",
          id: "edit",
        },
        {
          name: "Delete",
          id: "update",
          data: {
            delete: true,
          },
        },
      ],
      formOptions: {
        label: "Add new Custom balance",
        fields: [
          {
            name: "insurance_type",
            label: "Type",
            type: "dropdown",
            isRequired: true,
            err: "Type is required",
            returnID: true,
            returnObject: true,
            span: 1,
            lazyloadUrl: "vehicles/insurancetypes",
          },
          {
            name: "expiry_date",
            label: "Expiry date",
            type: "datepicker",
            disableInput: true,
            countryCode: "location.branch.code",
            allowTime: false,
            isRequired: true,
            err: "Date is required",
            span: 1,
          },
        ],
      },
    },
    // Add more fields as needed
  ];

  //Roles
  const captain = process.env.REACT_APP_CAPTAIN_ID;
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const managerRole = process.env.REACT_APP_MANAGER_ROLE;
  const financeRole = process.env.REACT_APP_FINANCE_ROLE;
  const operator = process.env.REACT_APP_OPERATOR_ROLE;
  const rentalPartnerRole = process.env.REACT_APP_PARTNER_ROLE;
  const clientRole = process.env.REACT_APP_CLIENT_ROLE;

  const tabs = [
    {
      name: "Details",
      href: "#",
      current: true,
      allowedRoles: [admin, managerRole, financeRole, captain, operator, clientRole,rentalPartnerRole],
      fields: [
        "id",
        "type",
        "brand",
        "model",
        "class",
        "plate",
        "year",
        "location",
        "odometer",
        "color",
        "class_display",
        "passengers",
        "fuel_type",
        "fuel_level",
        "transmission",
        "status",
        "partner_vehicle",
        "note",
        "image",
        // "registration_document",
        "registration_documents",
        // "insurance_document",
        "insurance_documents",
        "vehicle_insurance",
        "files",
      ],
    },
    {
      name: "Damages",
      href: "#",
      current: false,
      allowedRoles: [admin, managerRole, financeRole, captain, operator, rentalPartnerRole, clientRole],
      fields: ["damageImage", "vehicle_damages"],
    },
    {
      name: "Contracts",
      href: "#",
      current: false,
      allowedRoles: [admin, managerRole, financeRole, captain, operator],
      fields: ["temporaryRta", "contracts_display"],
    },
    {
      name: "Lending Contract",
      href: "#",
      current: false,
      allowedRoles: [admin, managerRole, financeRole, captain, operator],
      fields: ["lending-contract"],
    },
  ];

  const [fields, setfields] = useState(initFields);
  const [_tabs, setTabs] = useState([]);

  useEffect(() => {
    var interval = setInterval(async function () {
      const currentRole = await waitForCookie("_r");
      if (currentRole) {
        const __tabs = tabs.filter((x) => x.allowedRoles.includes(currentRole));
        if (__tabs?.length > 0) {
          __tabs[0].current = true;
        }
        setTabs(__tabs);
        clearInterval(interval);
      }
    }, 100);

    return () => {
      setTabs([]);
    };
  }, []);

  useEffect(() => {
    var interval = setInterval(async function () {
      const currentRole = await waitForCookie("_r");
      if (currentRole) {
        const __tabs = tabs.filter((x) => x.allowedRoles.includes(currentRole));
        if (__tabs?.length > 0) {
          __tabs[0].current = true;
        }
        setTabsData(__tabs);
        clearInterval(interval);
      }
    }, 100);

    return () => {
      setTabsData([]);
    };
  }, []);

  const getPromises = (temp) => {
    return [
      fetchDataAndMapToField(config, "vehiclebrands", "brand", temp),
      fetchDataAndMapToField(config, "vehicleclasses", "class", temp),
      fetchDataAndMapToField(config, "vehicletypes", "type", temp, "Name"),
      fetchDataAndMapToField(config, "colors", "color", temp),
      fetchDataAndMapToField(
        config,
        "fleetlocations",
        "location",
        temp,
        undefined,
        undefined,
        undefined,
        "branch"
      ),
      fetchDataAndMapToField(config, "contacts", "rental_contact", temp),
    ];
  };
  return {
    apiRoute,
    initFields,
    onlyForm,
    getPromises,
    tabs,
    tabsData,
    captain,
    admin,
    managerRole,
    operator,
    financeRole,
    rentalPartnerRole,
    clientRole,
  };
};

export default useVehiclesLogic;
